import { Directive, Input, } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS, ValidationErrors } from '@angular/forms';
import { SharedDataService } from '../Services/shared-data/shared-data.service';
import { SuppliersService } from '../Services/suppliers.service';
import { Supplier } from '../Models/Supplier';

@Directive({
  selector: '[SiretHq]',
  providers: [{
    provide: NG_VALIDATORS, useExisting: SiretHqDirective, multi:
      true
  }]
})
export class SiretHqDirective  implements Validator  {

  constructor(private suppliersSvc:SuppliersService,private sharedDatasSvc:SharedDataService) { }
  @Input() SiretHq:Supplier;
  

  validate(control: AbstractControl): ValidationErrors | null {
    if ((control.value||'')==''){
      return null;
    }
    else if ((control.value||'').trim()==(this.SiretHq.Siret||'').trim()){
      return {'Errors/SiretHq':'Ce n° de siret ne peut pas être le siège'};
    } else {
      return null;
    }
  }
}

